<span class="myvf-ui-button-wrapper" (click)="btnClicked($event)">
  <ng-content></ng-content>
</span>
